import { ChangeDetectorRef, Component, Inject, ViewChild } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { EquipmentHistoricalDataComponent } from 'app/modules/equipment-registration/component/equipment-historical-data/equipment-historical-data.component';
import module from 'app/modules/well-healthiness/well-healthiness.module';
import { EMPTY, map, merge, Subject, switchMap, takeUntil } from 'rxjs';
import { WellHealthinessService } from '../../services/well-healthiness.service';
import { handleFormatDate } from 'app/core/shared/helper/date.helper';

@Component({
  selector: 'app-wh-history',
  standalone: true,
  imports: module,
  templateUrl: './wh-history.component.html',
  styleUrl: './wh-history.component.scss'
})
export class WellHealthinessHistoryComponent {
  @ViewChild(MatPaginator) private _paginator: MatPaginator;
  @ViewChild(MatSort) private _sort: MatSort;
  private _unsubscribeAll: Subject<any> = new Subject<any>();

  searchForm: UntypedFormGroup;
  dt: any//Datatable<any>;
  startingIndex: number = 0
  isLoading: boolean = false

  public filterData = {
    pageNumber: 1,
    pageSize: 10,
    wellName: '',
    reportType: '',
    startDate: null,// new Date(),
    endDate: null
  }

  constructor(
    public dialogRef: MatDialogRef<EquipmentHistoricalDataComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private _formBuilder: UntypedFormBuilder,
    public service: WellHealthinessService,
    private _changeDetectorRef: ChangeDetectorRef,
  ) { }

  ngOnInit() {
    this.setSearch();
    this.setDataTable();
    this.setPage({ offset: 0 });
  }

  ngAfterViewInit() {
    if (this._sort && this._paginator) {
      // Set the initial sort
      this._sort.sort({
        id: 'field',
        start: 'asc',
        disableClear: true,
      });

      // Mark for check
      this._changeDetectorRef.markForCheck();

      // If the user changes the sort order...
      this._sort.sortChange
        .pipe(takeUntil(this._unsubscribeAll))
        .subscribe(() => {
          // Reset back to the first page
          this._paginator.pageIndex = 0;

          this.onSort(this._sort)
        });

      // Get platform types if sort or page changes
      merge(this._sort.sortChange, this._paginator.page).pipe(
        switchMap(() => {
          // this.isLoading = true;

          let pageInfo = {
            'count': this._paginator.length,
            'pageSize': this._paginator.pageSize,
            'limit': this._paginator.pageSize,
            'offset': this._paginator.pageIndex
          }
          this.setPage(pageInfo); // Emit page number

          return EMPTY
        }),
        map(() => {
          this.isLoading = false;
        }),
      ).subscribe();
    }
  }

  onSort(sort: any) {
    if (!sort) return;

    this.searchForm.patchValue({
      OrderBy1: sort.active,
      OrderDir: sort.direction,
    });

    this.setPage({ offset: 0 });
  }

  setSearch() {
    this.searchForm = this._formBuilder.group({
      WellStringId: this.data.wellStringId,
      Page: [0],
      PageSize: [10],
      OrderBy1: [null],
      OrderDir: [null],
      WellName: [null],
      PlatformName: [null],
      StringName: [null],
      FieldName: [null],
    });

    this.searchForm.get('PageSize').valueChanges.subscribe(value => this.setSize(value));
  }

  setSize(size: number) {
    this.dt.page.size = size;
    this.dt.page.offset = 0
    this.setPage({ offset: this.dt.page.offset });
  }


  setDataTable() {
    this.dt = {
      page: {
        size: this.searchForm.get('PageSize')?.value,
        totalRecords: 0,
        totalPages: 0,
        offset: 0,
      },
      rows: [],
    };
  }

  setPage(pageInfo) {
    this.dt.page.offset = pageInfo.offset;
    this.startingIndex = this.dt.page.offset * this.dt.page.size

    this.searchForm.patchValue({
      Page: this.dt.page.offset + 1,
    });

    const params = this.searchForm.value;
    this.service.getWellHealthinessHistorical(params)
      .subscribe((pagedData) => {
        this.dt.page.totalPages = pagedData.data.totalPages;
        this.dt.page.totalRecords = pagedData.data.totalRecords;
        this.dt.rows = pagedData.data.data;
      });
  }

  handleFormatDate(dateString: string, withTime: boolean = false) {
    return handleFormatDate(dateString, withTime)
  }

  onPageChange(event) {
    this.setPage({ offset: event.pageIndex });
  }
}
